var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _circle, _path32, _path33, _path34, _circle2, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _rect, _rect2, _rect3, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoHl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C9D644;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.4,376.3c1.3,1.1,2.5,2.2,3.8,3.3l3.2-3.8c-1.3-1.1-2.5-2.1-3.7-3.2L145.4,376.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.6,351l-4,3.1c1,1.3,2.1,2.7,3.2,4l3.9-3.2C130.6,353.5,129.6,352.3,128.6,351z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.9,358.6l-3.8,3.3c1.1,1.3,2.3,2.5,3.4,3.8l3.7-3.4C137.1,361,136,359.8,134.9,358.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138,369.3c1.2,1.2,2.4,2.4,3.6,3.5l3.4-3.6c-1.2-1.1-2.4-2.3-3.5-3.4L138,369.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.8,343l-4.1,2.8c0.9,1.4,1.9,2.8,2.9,4.2l4-2.9C124.7,345.7,123.7,344.4,122.8,343z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.5,334.7l-4.3,2.6c0.9,1.5,1.8,2.9,2.7,4.3l4.2-2.7C119.2,337.5,118.4,336.1,117.5,334.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.8,326.1l-4.5,2.3l2.4,4.5l4.4-2.4C114.3,329,113.5,327.5,112.8,326.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254,95.5h3.8l0.1-5h-5v5H254z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.1,95.9l4.9-0.3l-0.2-5l-5.1,0.3L243.1,95.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.2,92.3c-1.7-0.2-3.4-0.5-5-0.7l-0.6,5l4.9,0.6L278.2,92.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M388.8,170.6l4.3-2.6c-0.9-1.4-1.8-2.9-2.7-4.3l-4.2,2.8C387.1,167.8,388,169.2,388.8,170.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.4,162.4l4.1-2.9c-1-1.4-2-2.8-3-4.1l-4,3C381.5,159.7,382.4,161.1,383.4,162.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.7,143.7c-1.1-1.2-2.3-2.5-3.5-3.7l-3.6,3.5c1.1,1.2,2.3,2.4,3.4,3.6L374.7,143.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M377.4,154.6l3.9-3.1l-3.3-3.9l-3.8,3.3C375.4,152,376.4,153.3,377.4,154.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.8,179.2l4.4-2.4c-0.8-1.5-1.6-3-2.5-4.4l-4.3,2.5C392.2,176.3,393,177.7,393.8,179.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398.1,188l4.5-2.1c-0.7-1.5-1.4-3.1-2.2-4.6l-4.5,2.2C396.8,184.9,397.5,186.4,398.1,188z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.7,95.8l1.3,4.8l4.8-1.2l-1.1-4.9C216,94.9,214.3,95.3,212.7,95.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5,98.4l4.8-0.9l-0.8-4.9l-5,0.9L223.5,98.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.1,91.1c-1.7-0.1-3.4-0.3-5.1-0.4l-0.3,5l4.9,0.3L268.1,91.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.6,136.4c-1.2-1.2-2.5-2.3-3.7-3.5l-3.4,3.7c1.2,1.1,2.4,2.2,3.6,3.4L367.6,136.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M402,197.1l4.7-1.8c-0.6-1.6-1.2-3.2-1.9-4.7l-4.6,1.9C400.8,194,401.4,195.5,402,197.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.3,96.8l4.9-0.6l-0.5-5l-5,0.6L233.3,96.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.7,99.5c-1.6-0.6-3.2-1.1-4.8-1.6l-1.5,4.8c1.5,0.5,3.1,1,4.7,1.5L307.7,99.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.1,129.6c-1.3-1.1-2.6-2.2-3.9-3.2l-3.1,3.9c1.3,1,2.5,2.1,3.8,3.1L360.1,129.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.1,103.1c-1.5-0.6-3.1-1.3-4.7-1.9l-1.8,4.7c1.5,0.6,3.1,1.2,4.6,1.8L317.1,103.1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.1,94.1c-1.6-0.4-3.3-0.7-5-1l-0.9,4.9l4.8,0.9L288.1,94.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298,96.5c-1.6-0.5-3.3-0.9-4.9-1.3l-1.2,4.9l4.8,1.2L298,96.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.2,123.3c-1.3-1-2.7-2-4.1-3l-2.9,4.1c1.3,0.9,2.7,1.9,4,2.9L352.2,123.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343.9,117.4c-1.4-0.9-2.8-1.8-4.3-2.7L337,119c1.4,0.9,2.8,1.7,4.1,2.6L343.9,117.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.3,112.1c-1.5-0.8-3-1.7-4.4-2.5l-2.4,4.4c1.4,0.8,2.9,1.6,4.3,2.4L335.3,112.1z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.4,107.3c-1.5-0.7-3-1.5-4.6-2.2l-2.1,4.5c1.5,0.7,3,1.4,4.4,2.1L326.4,107.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 180.2,
    cy: 163.4,
    r: 8.7
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.2,183.6c11.2,0,20.2-9,20.2-20.2c0-11.2-9-20.2-20.2-20.2c-11.2,0-20.2,9-20.2,20.2 c0,11.1,9,20.2,20.1,20.2C180.1,183.6,180.2,183.6,180.2,183.6z M180.2,148.2c8.4,0,15.2,6.8,15.2,15.2s-6.8,15.2-15.2,15.2 s-15.2-6.8-15.2-15.2v0C165,155,171.8,148.2,180.2,148.2C180.2,148.2,180.2,148.2,180.2,148.2L180.2,148.2z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.2,187c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1C180.3,189.8,177.6,187,174.2,187 C174.3,187,174.2,187,174.2,187z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.8,143.6c3.4,0,6.1-2.7,6.1-6.1s-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1 C189.7,140.9,192.4,143.6,195.8,143.6z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 149.9,
    cy: 163.4,
    r: 6.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254,0C113.8,0,0,113.8,0,254.1S113.8,508,254,508s254-113.7,254-253.9S394.3,0,254,0z M426.6,426.5 c-95.2,95.3-249.7,95.4-345.1,0.2c-70.3-70.2-91-176.1-52.3-267.6c12.2-29,29.9-55.4,52.3-77.6c95.3-95.3,249.9-95.3,345.2,0 c70.2,70.2,90.9,176,52.3,267.5C466.7,378,448.9,404.3,426.6,426.5z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.6,405.4h227V249h-227V405.4z M191.6,259h207v136.4h-207V259z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M357.4,186.6c0-2.8-2.2-5-5-5h-17.9c-2.8,0-5,2.2-5,5v3.8l-5.9-10.3l-17.2,3.4l-21.2,2.3l-14.6-12.5l-6.1-4.8 l-26.4,0.9l-12.7,0.6l-6.3-9.6l5-11.5l-12.7-23.2l-7.8-8.3l5.4-20.9l8.6-10.9l11.2-9.5l13-9l3.4-14.1L235,46h-12.4l-11.5,13.5 l-14.7,10l-9.6,3.5L166,70.1l-24.2,17.2l-0.6,1.1c-2.4,4.6-5.3,10.1-6.4,12l-1,0.7l-1.8,10.3l-1.8,5.1l-4.9,1.9l-8,10.6l-12.9,3.1 l1.5,7.6L95,128.8L86.2,139l2.5,16.9l-6.4,12.6l11.5,29.4l-3.9,4l3.3,38.8l6.8,12.2l-2.7,6.5L76,275.7l-13.2,10.5l2.2,20.4l23.7,16 l15.1,1.8l34.5,4.5c3,2.1,11.9,8.5,19.3,14V401c0,14.9,12.1,27,27,27l0,0h221.1c14.9,0,27-12.1,27-27l0,0V202.9h-75.4v-16.3H357.4z  M339.5,191.6h7.9v31.1h-7.9V191.6z M143.2,320l-1-0.7l-37-4.8l-12.8-1.6l-17.9-12l-1.1-10.3l8.8-7l23.3-18l5.6-13.4l-8.1-14.6 l-2.7-32.1l5.2-5.3L93.3,169l5.8-11.4l-1.8-12.4l10.3,10.3l12,2.3l-3.6-18.3l7-1.7l8.5-11.1l6.6-2.5l3.6-10.3l1.4-7.9 c1.1-1.7,2.9-5.1,6.5-11.9l19-13.5l19.3,2.6l13-4.8l16.9-11.5l9.4-11h4.7l2.1,1.5l-0.9,3.8l-10.1,7l-12.6,10.6l-10.6,13.4l-7.3,28.2 l10.7,11.4l9.7,17.8l-5.2,12l12.4,18.8l18.3-0.8l22.7-0.8l3,2.4l17.8,15.2l25.8-2.8l10.8-2.1l3.3,5.7L318,203h-57v-16.3 c0-2.8-2.3-5.1-5.1-5.1h-17.8c-2.8,0-5.1,2.3-5.1,5.1V203h-75.4v127.6C150.3,325.1,143.3,320.1,143.2,320z M251.1,191.6v31.1h-7.9 v-31.1H251.1z M422.9,212.9V401c0,9.4-7.6,17-17,17l0,0H184.7c-9.4,0-17-7.6-17-17l0,0V212.9h65.4v14.7c0,2.8,2.3,5.1,5.1,5.1H256 c2.8,0,5.1-2.3,5.1-5.1v-14.7h68.4v14.8c0,2.8,2.2,5,5,5h17.9c2.8,0,5-2.2,5-5v-14.8L422.9,212.9z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.8,287.3h19.7v-19.7h-19.7V287.3z M261.8,272.6h9.7v9.7h-9.7V272.6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285,287.3h19.7v-19.7H285V287.3z M290,272.6h9.7v9.7H290V272.6z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.1,287.3h19.7v-19.7h-19.7V287.3z M318.1,272.6h9.7v9.7h-9.7V272.6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.3,287.3H361v-19.7h-19.7V287.3z M346.3,272.6h9.7v9.7h-9.7V272.6z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.5,287.3h19.7v-19.7h-19.7V287.3z M374.5,272.6h9.7v9.7h-9.7V272.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.5,312.5h19.7v-19.7h-19.7V312.5z M205.5,297.7h9.7v9.7h-9.7V297.7z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.7,312.5h19.7v-19.7h-19.7V312.5z M233.7,297.7h9.7v9.7h-9.7V297.7z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.8,312.5h19.7v-19.7h-19.7V312.5z M261.8,297.7h9.7v9.7h-9.7V297.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285,312.5h19.7v-19.7H285V312.5z M290,297.7h9.7v9.7H290V297.7z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.1,312.5h19.7v-19.7h-19.7V312.5z M318.1,297.7h9.7v9.7h-9.7V297.7z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.3,312.5H361v-19.7h-19.7V312.5z M346.3,297.7h9.7v9.7h-9.7V297.7z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.5,312.5h19.7v-19.7h-19.7V312.5z M374.5,297.7h9.7v9.7h-9.7V297.7z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.5,337.6h19.7v-19.7h-19.7V337.6z M205.5,322.9h9.7v9.7h-9.7V322.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.7,337.6h19.7v-19.7h-19.7V337.6z M233.7,322.9h9.7v9.7h-9.7V322.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.8,337.6h19.7v-19.7h-19.7V337.6z M261.8,322.9h9.7v9.7h-9.7V322.9z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285,337.6h19.7v-19.7H285V337.6z M290,322.9h9.7v9.7H290V322.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 313.1,
    y: 317.9,
    className: "st0",
    width: 19.7,
    height: 19.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 341.3,
    y: 317.9,
    className: "st0",
    width: 19.7,
    height: 19.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 369.5,
    y: 317.9,
    className: "st0",
    width: 19.7,
    height: 19.7
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.5,362.8h19.7v-19.7h-19.7V362.8z M205.5,348.1h9.7v9.7h-9.7V348.1z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.7,362.8h19.7v-19.7h-19.7V362.8z M233.7,348.1h9.7v9.7h-9.7V348.1z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.8,362.8h19.7v-19.7h-19.7V362.8z M261.8,348.1h9.7v9.7h-9.7V348.1z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285,362.8h19.7v-19.7H285V362.8z M290,348.1h9.7v9.7H290V348.1z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.1,362.8h19.7v-19.7h-19.7V362.8z M318.1,348.1h9.7v9.7h-9.7V348.1z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.3,362.8H361v-19.7h-19.7V362.8z M346.3,348.1h9.7v9.7h-9.7V348.1z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.5,362.8h19.7v-19.7h-19.7V362.8z M374.5,348.1h9.7v9.7h-9.7V348.1z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.5,388h19.7v-19.7h-19.7V388z M205.5,373.3h9.7v9.7h-9.7V373.3z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.7,388h19.7v-19.7h-19.7V388z M233.7,373.3h9.7v9.7h-9.7V373.3z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.8,388h19.7v-19.7h-19.7V388z M261.8,373.3h9.7v9.7h-9.7V373.3z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285,388h19.7v-19.7H285V388z M290,373.3h9.7v9.7H290V373.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoHl);
export default __webpack_public_path__ + "static/media/Icono-HL_.a7c93224eb1a003f8aaeaf6bcda3ff51.svg";
export { ForwardRef as ReactComponent };